<template>
  <el-dialog
    title="导入金税开票信息"
    :visible.sync="isShow"
    width="1000px"
    destroy-on-close
    @close="closeDoalog"
  >
    <el-button type="text" size="medium" @click="downloadTemplate">
      下载导入模板
    </el-button>

    <div class="upload-wrap">
      <span>选择文件并上传：</span>
      <el-upload
        action=""
        multiple
        :show-file-list="false"
        :http-request="uploadTaxInvoice"
        style="display: inline-block;margin: 0 10px 0 0"
      >
        <el-button :loading="isUploadLoading" type="primary">
          上传
        </el-button>
      </el-upload>
    </div>

    <p>错误信息</p>
    <el-table :data="errorList" border height="300">
      <el-table-column
        prop="line"
        label="行号"
      />
      <el-table-column
        prop="failMsg"
        label="错误提示"
      />
    </el-table>

    <el-table :data="tableData" border height="300" style="margin-top: 20px;">
      <el-table-column type="index" label="序号" align="left" />
      <el-table-column prop="approvalNumber" label="开票申请单号" align="left" />
      <el-table-column prop="orderNum" label="订单编号" align="left" />
      <el-table-column prop="invoiceCode" label="发票代码" align="left" />
      <el-table-column prop="invoiceNo" label="金税发票编号" align="left" />
      <el-table-column prop="invoiceDate" label="金税发票日期" align="left" />
      <el-table-column prop="exportInvoiceNo" label="出口发票号" align="left" />
    </el-table>

    <div slot="footer">
      <el-button type="default" @click="closeDoalog">
        取消导入
      </el-button>
      <el-button type="primary" :disabled="errorList.length !== 0" :loading="isSubmitLoading" @click="submitImport">
        确定导入
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { importTaxInvoiceCheck, importTaxInvoice } from '@/API';
import { downloadUrlFile } from '@/libs/util';

export default {
  data () {
    return {
      isShow: false,
      isUploadLoading: false,
      errorList: [],
      tableData: [],
      isSubmitLoading: false
    };
  },

  methods: {
    openDialog () {
      this.isShow = true;
    },

    closeDoalog () {
      this.errorList = [];
      this.tableData = [];
      this.isShow = false;
      this.$emit('init-data');
    },

    downloadTemplate () {
      downloadUrlFile('/导入金税开票信息模板.xlsx');
    },

    // 校验导入金税发票
    uploadTaxInvoice (upload) {
      this.isUploadLoading = true;
      let formDate = new FormData();
      formDate.append('file', upload.file);

      importTaxInvoiceCheck(formDate)
        .then(res => {
          this.isUploadLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            this.errorList = data.errorList;
            this.tableData = data.taxInvoiceExcelList;
          }
        })
        .catch(() => {
          this.isUploadLoading = false;
        });
    },

    submitImport () {
      this.isSubmitLoading = true;
      let params = {
        taxInvoiceExcelList: this.tableData
      };

      importTaxInvoice(params)
        .then(res => {
          this.isSubmitLoading = false;
          let { status } = res.data;
          if (status === '200') {
            this.$message.success('上传成功');
            this.closeDoalog();
          }
        }).catch(() => {
          this.isSubmitLoading = false;
        });
    }

  }
};
</script>

<style scoped>
.upload-wrap{
  margin: 10px 0 20px;
}
</style>
